import { withLenses } from '@dhmk/zustand-lens';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { create as _create, StateCreator } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { MergedInterfaces } from './models';
import createAccountSlice from './modules/AccountStore';
import createBreedSlice from './modules/BreedStore';
import createConditionSlice from './modules/ConditionStore';
import createCountrySlice from './modules/CountryStore';
import createDeviceSlice from './modules/DeviceStore';
import createHouseholdInviteSlice from './modules/HouseholdInviteStore';
import createHouseholdSlice from './modules/HouseholdStore';
import createHouseholdUserSlice from './modules/HouseholdUserStore';
import createInviteSlice from './modules/InviteStore';
import createLanguageSlice from './modules/LanguageStore';
import createNotificationSlice from './modules/NotificationStore';
import createPetSlice from './modules/PetStore';
import createTagSlice from './modules/TagStore';
import createProductSlice from './modules/ProductStore';
import createReportSlice from './modules/ReportStore';
import createTimelineSlice from './modules/TimelineStore';
import createTimezoneSlice from './modules/TimezoneStore';
import createUISlice from './modules/UIStore';
import createWiFiDeviceSlice from './modules/WiFiDeviceStore';
import createRetrySlice from './modules/RetryStore';
import createTourSlice from './modules/TourStore';

const resetters: (() => void)[] = [];

// @ts-ignore
export const storeSlices = withLenses((...a) => ({
  ...createPetSlice(...a),
  ...createTagSlice(...a),
  ...createHouseholdSlice(...a),
  ...createDeviceSlice(...a),
  ...createAccountSlice(...a),
  ...createCountrySlice(...a),
  ...createTimelineSlice(...a),
  ...createTimezoneSlice(...a),
  ...createHouseholdInviteSlice(...a),
  ...createHouseholdUserSlice(...a),
  ...createUISlice(...a),
  ...createInviteSlice(...a),
  ...createNotificationSlice(...a),
  ...createLanguageSlice(...a),
  ...createReportSlice(...a),
  ...createConditionSlice(...a),
  ...createBreedSlice(...a),
  ...createWiFiDeviceSlice(...a),
  ...createRetrySlice(...a),
  ...createProductSlice(...a),
  ...createTourSlice(...a),
}));

const create = (<T>(f: StateCreator<T> | undefined) => {
  if (f === undefined) return create;
  const store = _create(f);
  const initialState = store.getState();
  resetters.push(() => {
    store.setState(initialState, true);
  });
  return store;
}) as typeof _create;

const useBoundStore = create<MergedInterfaces>()(
  // @ts-ignore
  persist(storeSlices, {
    name: 'store',
    storage: createJSONStorage(() => AsyncStorage),
    // @ts-ignore
    merge: (persistedState, currentState) => {
      return Object.fromEntries(
        Object.entries(currentState).map(([key, value]) => [
          key,
          {
            // @ts-ignore
            ...currentState[key],
            // @ts-ignore
            ...persistedState[key],
          },
        ]),
      );
    },
  }),
);

export const resetAllStores = () => {
  resetters.forEach(resetter => {
    resetter();
  });
};

export default useBoundStore;
